module.exports = __webpack_public_path__ + "static/img/home_bg.9215b84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/home_bg.png
// module id = UdfV
// module chunks = 3